<div class="dialog-container">
  <h5 mat-dialog-title class="text-center">أضف ملف آخر</h5>
  <div mat-dialog-content>
    <div class="text-center">
      <p class="dialog-message mt-2">ادخل اسم الملف اولا ثم ضفه من جهازك</p>
    </div>
    <form class="needs-validation" [formGroup]="addFileFormGroup">
      <div class="form-group">
        <label for="" class="form-label">اسم الملف</label>
        <input type="text" formControlName="fileName" class="form-control" placeholder="أدخل اسم الملف">
      </div>
      <div class="form-group">
        <file-input [file]="file" [fileLabel]="'fileLabel'" [fileName]="'name'"
          (save)="handleFile($event)" (delete)="deleteFile()">
        </file-input>
      </div>
    </form>
  </div>
  <div mat-dialog-actions class="setup-footer actions-double">
    <button class="btn btn-cancel" type="button" mat-dialog-close>إلغاء</button>
    <button class="btn btn-green" type="submit" [disabled]="addFileFormGroup.invalid || !file.fileLabel" (click)="save()">
      موافق
    </button>
  </div>
</div>
